export default {
	messageTemplates: {

	},
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/lib/i18n/lang/en/en_metadata.js